import React from 'react';
import Home from './components';
import Social from './Social'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
      <Social />
      <Home/>
    </>
  );
}

export default App;
